import InputAdornment from '@mui/material/InputAdornment'
import TextField, { type TextFieldProps } from '@mui/material/TextField'
import SearchIcon from '@mui/icons-material/Search'
import { type ElementType } from 'react'

const resolveIconComponent = (iconSource: unknown): ElementType => {
  if (iconSource && typeof iconSource === 'object' && 'default' in iconSource) {
    return (iconSource as { default: ElementType }).default
  }

  return iconSource as ElementType
}

type SearchFieldProps = TextFieldProps

export const SearchField = ({ ...props }: SearchFieldProps) => {
  const SearchIconComponent = resolveIconComponent(SearchIcon)

  return (
    <TextField
      {...props}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            {SearchIconComponent ? <SearchIconComponent /> : null}
          </InputAdornment>
        ),
      }}
    />
  )
}
